import HorizontalProgressBarCount from "./HorizontalProgressBarCount";
import styles from "./HorizontalProgressBarLegendCount.module.css";

// Renders: ● Critical  [====bar====]  42
const HorizontalProgressBarLegendCount = ({
  label,
  value,
  total,
  color,
  isLoading,
  onClick,
}) => {
  return (
    <div className={styles.row}>
      <div className={styles.legend}>
        <span
          className={[styles.dot, isLoading ? "shimmer" : ""].join(" ")}
          style={isLoading ? {} : { backgroundColor: color }}
        />
        {isLoading ? (
          <span className={["shimmer", styles.labelShimmer].join(" ")} />
        ) : (
          <span className={styles.label}>{label}</span>
        )}
      </div>
      <HorizontalProgressBarCount
        value={value}
        total={total}
        color={color}
        isLoading={isLoading}
        label={label}
        onClick={onClick}
      />
    </div>
  );
};

export default HorizontalProgressBarLegendCount;
